'use strict';

const React = require('react');

const PageNavigationContext = React.createContext({
  id: "",
  setId: () => {
  },
  toggleExpand: (_rowId) => null
});

module.exports = PageNavigationContext;
//# sourceMappingURL=PageNavigationContext.cjs.js.map
